import {processApiRequest} from "../../Common/saga";
import * as ACTION from "../constants";
import apiService from "../apiService";

export function* getDetailWarehouse(action) {
	yield processApiRequest(ACTION.FETCH_DETAIL_WAREHOUSE, () => apiService.detailWarehouse(action.payload.id), action.payload);
}
